import { useRef } from 'react';
import { isBot } from '@/utils/helpers';

export const useBotSearchParams = (use = true) => {
  const bot = useRef(isBot());
  if (!use) return false;

  const { pathname: path, searchParams: qs } = new URL(window.location.href);
  const type = qs.get('category_type');
  const notCanon = Boolean(qs.get('q') || qs.get('keywords') || qs.get('size') !== '100');
  const botRedirected = Boolean(bot.current && notCanon);

  if (botRedirected)
    // eslint-disable-next-line no-restricted-globals
    history.replaceState({}, '', `${path}?size=100${type ? `&category_type=${type}` : ''}`);
  return botRedirected;
};
